import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的客户开票信息ID', 'integer', 'blur', false), min: 1},
  ],
}

// export let formRules = {
//   company_name: [
//     {...makeRule('请输入公司名称', 'string')},
//   ],
//   bank_info: [
//     {...makeRule('请输入开户行及账户', 'string')},
//   ],
//   address_phone: [
//     {...makeRule('请输入地址及电话', 'string')},
//   ],
//   tax_number: [
//     {...makeRule('请输入税号', 'string')},
//   ],
// }

export let formRules = {
  company_name: [
    {required: true, message: '公司名称不能为空', trigger: 'blur'},
  ],
  bank_info: [
    {required: true, message: '开户行及账号不能为空', trigger: 'blur'},
  ],
  address_phone: [
    {required: true, message: '地址及电话不能为空', trigger: 'blur'},
  ],
  tax_number: [
    {required: true, message: '税号不能为空', trigger: 'blur'},
    {
      pattern: /^[0-9a-zA-Z]+$/,
      message: '格式不正确',
      trigger: 'blur'
    }
  ],
  customer_ids: [
    {required: true, message: '使用客户不能为空', trigger: 'blur'},
  ],
  pay_condition_ids: [
    {required: true, message: '账期不能为空', trigger: 'blur'},
  ],
}



// WEBPACK FOOTER //
// ./src/views/customer-receipt/customer-receipt.rules.js